import React from 'react';
import { ApolloProvider } from '@apollo/client';
import client from '../lib/apolloClient';
import AppLayout from '../components/Succeedo/Layout/AppLayout';
import DealTeamSnapshotView from '../components/Succeedo/DealTeam/DealTeamSnapshotView';

const SucceedoDealTeamSnapshotViewContainer = (props, _railsContext) => (
  <ApolloProvider client={client}>
    <AppLayout breadcrumb="DEAL TEAM SNAPSHOT">
      <DealTeamSnapshotView
        dealTeamId={props.dealTeamId}
        vaultDocumentId={props.vaultDocumentId}
        snapshotType={props.snapshotType}
        sharedAt={props.sharedAt}
        sharedByName={props.sharedByName}
        teamName={props.teamName}
        note={props.note}
        sharedWithRoles={props.sharedWithRoles}
        snapshot={props.snapshot}
      />
    </AppLayout>
  </ApolloProvider>
);

export default SucceedoDealTeamSnapshotViewContainer;
